const WhyChooseUs = () => {
  const features = [
    {
      number: '01',
      title: 'Legacy of Reliability',
      description: 'With 110 years of continuous operation since 1915, we have built an unmatched reputation for dependable service and operational excellence.',
      image: 'https://public.readdy.ai/ai/img_res/88f2d7ccd8549b92bb5ac798cd6ae52f.jpg',
      points: [
        'Over a century of proven track record',
        'Family-owned and operated excellence',
        'Trusted by thousands of businesses',
      ],
    },
    {
      number: '02',
      title: 'Modern Fleet & Technology',
      description: 'Our state-of-the-art fleet combined with cutting-edge tracking technology ensures your freight is always monitored and delivered efficiently.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20semi%20truck%20with%20advanced%20technology%20dashboard%2C%20GPS%20tracking%20system%2C%20digital%20logistics%20interface%2C%20professional%20commercial%20photography%2C%20warm%20lighting%2C%20high-tech%20transportation%20equipment%2C%20orange%20accent%20lighting&width=800&height=600&seq=modern-tech-002&orientation=landscape',
      points: [
        'Real-time GPS tracking on all shipments',
        'Well-maintained, fuel-efficient vehicles',
        'Advanced route optimization systems',
      ],
    },
    {
      number: '03',
      title: 'Dedicated Customer Service',
      description: 'Our experienced team provides personalized support 24/7, ensuring your logistics needs are met with professionalism and care.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20representative%20with%20headset%20in%20modern%20office%2C%20warm%20lighting%2C%20friendly%20business%20environment%2C%20logistics%20coordination%20center%2C%20professional%20photography%20with%20warm%20orange%20tones&width=800&height=600&seq=customer-service-003&orientation=landscape',
      points: [
        '24/7 customer support availability',
        'Dedicated account managers',
        'Proactive communication and updates',
      ],
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <span className="w-2 h-2 bg-[#FF8C42] rounded-full mr-3"></span>
            <span className="text-[#FF8C42] text-sm font-semibold uppercase tracking-wider">
              Why Choose Us
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2A2A2A]">
            The Sodrel Advantage
          </h2>
        </div>

        <div className="space-y-24">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } items-center gap-12`}
            >
              <div className="flex-1">
                <div className="relative">
                  <span className="text-[120px] font-bold text-[#FF8C42]/10 absolute -top-8 left-0">
                    {feature.number}
                  </span>
                  <h3 className="text-3xl md:text-4xl font-bold text-[#2A2A2A] mb-6 relative z-10">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-lg text-[#6B6B6B] leading-relaxed mb-8">
                  {feature.description}
                </p>
                <ul className="space-y-4">
                  {feature.points.map((point, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-[#FF8C42] text-xl mr-3 mt-1"></i>
                      <span className="text-[#2A2A2A] font-medium">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex-1">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-[400px] object-cover"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;